import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  href,
  children,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-5 py-5 text-base sm:px-8 sm:text-lg md:text-xl' : 'px-5 py-4 text-sm sm:text-base md:text-lg';
  return <a href={href} className={`group inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl border-b-4 border-gold-strong bg-gold font-extrabold uppercase tracking-wide text-brand shadow-[0_12px_30px_-12px_rgba(20,83,45,0.45)] transition-[transform,background-color] duration-150 ease-out hover:bg-gold-strong active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 ${sizing} ${className}`} data-id="element-25" data-mp="qjimbydj5c57">
      <span className="whitespace-nowrap" data-id="element-26" data-mp="159q4eczmkt5d">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-27" data-mp="15bazc3puqe3r" />
    </a>;
}